import React, {Component} from 'react'
import {routesUrls} from '../../../settings/routes'
import {connect} from 'react-redux'
import {handleRefreshCaptcha, handleCaptchaInit, captchaHashSelector, handleGetCaptchaHash} from '../../../modules/app'


class CaptchaImg extends Component {
    state = {
        now : Date.now()
    }
    render() {
        const {captchaHash} = this.props
        const {now} = this.state
        return (
            <img
                onClick={this.handleClick}
                className="captcha-img pointer"
                src={captchaHash ? `${routesUrls.captchaImg}?v=${now}` : ""}
                alt=""
            />
        )
    }
    componentDidMount() {
        const {handleCaptchaInit} = this.props
        handleCaptchaInit()
    }
    componentWillReceiveProps(nextProps, nextContext) {
        let {captchaHash : nextCaptchaHash} = nextProps
        let {captchaHash : currCaptchaHash} = this.props
        if (nextCaptchaHash !== currCaptchaHash) {
            this.refreshImg()
        }
    }

    handleClick = () => this.props.handleRefreshCaptcha(this.refreshImg)

    refreshImg = () => this.setState({now : Date.now()})
}

export default connect(
    state => ({
        captchaHash : captchaHashSelector(state)
    }),
    {handleRefreshCaptcha, handleCaptchaInit}
)(CaptchaImg)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/CaptchaImg.js